import LegalPageLayout from '../components/LegalPageLayout';
import { TERMS_AND_CONDITIONS } from '../constants/legal';

function TermsAndConditions() {
  return <LegalPageLayout policy={TERMS_AND_CONDITIONS} />;
}

export default TermsAndConditions;
